export default {
  DEVELOPMENT: [
    {
      id: "e8f6eaf4-e004-476f-a513-00b04936820f",
      enum_id: 0,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "RunUp",
      description: "RunUp",
    },
    {
      id: "a8070199-095f-466b-a599-4d9fba802790",
      enum_id: 1,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "RunDown",
      description: "RunDown",
    },
    {
      id: "fb449453-5395-4774-a3d3-2d594b91e712",
      enum_id: 2,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "Stop",
      description: "Stop",
    },
    {
      id: "db07b57a-ba2a-4c32-bebc-3019cfcf0959",
      enum_id: 0,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "CarCallLock",
      description: "CarCallLock",
      command: true,
    },
    {
      id: "7d85761a-197a-4419-b163-9b332bea0905",
      enum_id: 1,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "CarCallUnlock",
      description: "CarCallUnlock",
      command: true,
    },
    {
      id: "f2d7a18e-6cf5-4a20-af22-a079dd71a91e",
      enum_id: 2,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "RearCarCallLock",
      description: "RearCarCallLock",
      command: true,
    },
    {
      id: "afa7d515-fb5d-40ca-8004-0545f0df4239",
      enum_id: 3,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "RearCarCallUnlock",
      description: "RearCarCallUnlock",
      command: true,
    },
    {
      id: "c2641687-4ca5-4048-bfd1-b9500e3b31f3",
      enum_id: 16,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeCarCall",
      description: "EnergizeCarCall",
      command: true,
    },
    {
      id: "52a20aa3-d605-4fb0-b0bb-a32021c012c6",
      enum_id: 17,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeRearCarCall",
      description: "EnergizeRearCarCall",
      command: true,
    },
    {
      id: "77f84dcf-cb96-47f2-a0df-70f57cb3ed05",
      enum_id: 22,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "SecureCarCall",
      description: "SecureCarCall",
      command: false,
    },
    {
      id: "c9233251-d10c-4e1c-a405-d65c077ca1f5",
      enum_id: 23,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "SecureRearCarCall",
      description: "SecureRearCarCall",
      command: false,
    },
    {
      id: "9dbc6967-87f6-4e98-ba54-98560603d1e4",
      enum_id: 4,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpHallCallLock",
      description: "UpHallCallLock",
      command: true,
    },
    {
      id: "4284dff4-91e9-4263-a5cf-9cb435c0f44e",
      enum_id: 5,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpHallCallUnlock",
      description: "UpHallCallUnlock",
      command: true,
    },
    {
      id: "6aee30b0-f7ff-419d-a55b-1f00626406ad",
      enum_id: 10,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownHallCallLock",
      description: "DownHallCallLock",
      command: true,
    },
    {
      id: "aca19062-a962-4e57-83b9-99ab4fe9ea39",
      enum_id: 11,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownHallCallUnlock",
      description: "DownHallCallUnlock",
      command: true,
    },
    {
      id: "797ca9ac-8115-42f6-98aa-d976848a2f91",
      enum_id: 6,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpRearHallCallLock",
      description: "UpRearHallCallLock",
      command: true,
    },
    {
      id: "840f76cc-21f6-45f7-8a78-a923a74c040d",
      enum_id: 7,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpRearHallCallUnlock",
      description: "UpRearHallCallUnlock",
      command: true,
    },
    {
      id: "6925af3f-bf8a-474f-9f46-65095e30f011",
      enum_id: 8,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownRearHallCallLock",
      description: "DownRearHallCallLock",
      command: true,
    },
    {
      id: "33aa966d-7d51-4310-82f5-84669fccccac",
      enum_id: 9,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownRearHallCallUnlock",
      description: "DownRearHallCallUnlock",
      command: true,
    },
    {
      id: "6925af3f-bf8a-474f-9f46-65095e30f011",
      enum_id: 8,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpAssignedHallCall",
      description: "UpAssignedHallCall",
      command: true,
    },
    {
      id: "13f30eff-9789-44af-a2a5-9cc8c212bcbe",
      enum_id: 14,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownAssignedHallCall",
      description: "DownAssignedHallCall",
      command: true,
    },
    {
      id: "33aa966d-7d51-4310-82f5-84669fccccac",
      enum_id: 9,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpAssignedRearHallCall",
      description: "UpAssignedRearHallCall",
      command: true,
    },
    {
      id: "3fe369a8-e218-4939-a9a7-cb09787a6dce",
      enum_id: 15,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownAssignedRearHallCall",
      description: "DownAssignedRearHallCall",
      command: true,
    },
    {
      id: "4cf2ffb1-1cd9-4610-88f4-c3c9ba822ad3",
      enum_id: 18,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeUpHallCall",
      description: "EnergizeUpHallCall",
      command: false,
    },
    {
      id: "f5514348-6638-4f1f-ba11-90e1be5fe796",
      enum_id: 19,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeUpRearHallCall",
      description: "EnergizeUpRearHallCall",
      command: false,
    },
    {
      id: "273d6451-6f0f-402e-9341-028b1ddfea47",
      enum_id: 20,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeDownHallCall",
      description: "EnergizeDownHallCall",
      command: false,
    },
    {
      id: "be06bfdc-bd7a-4cf3-b83a-db1694ba2aa4",
      enum_id: 21,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeDownRearHallCall",
      description: "EnergizeDownRearHallCall",
      command: false,
    },
    {
      id: "b3c3c3dc-1d2a-4633-8f8e-71fe65851d5d",
      enum_id: 24,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "VIP",
      description: "VIP",
      command: true,
    },
  ],
  STAGING: [
    {
      id: "e8f6eaf4-e004-476f-a513-00b04936820f",
      enum_id: 0,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "RunUp",
      description: "RunUp",
    },
    {
      id: "a8070199-095f-466b-a599-4d9fba802790",
      enum_id: 1,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "RunDown",
      description: "RunDown",
    },
    {
      id: "fb449453-5395-4774-a3d3-2d594b91e712",
      enum_id: 2,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "Stop",
      description: "Stop",
    },
    {
      id: "db07b57a-ba2a-4c32-bebc-3019cfcf0959",
      enum_id: 0,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "CarCallLock",
      description: "CarCallLock",
      command: true,
    },
    {
      id: "7d85761a-197a-4419-b163-9b332bea0905",
      enum_id: 1,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "CarCallUnlock",
      description: "CarCallUnlock",
      command: true,
    },
    {
      id: "f2d7a18e-6cf5-4a20-af22-a079dd71a91e",
      enum_id: 2,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "RearCarCallLock",
      description: "RearCarCallLock",
      command: true,
    },
    {
      id: "afa7d515-fb5d-40ca-8004-0545f0df4239",
      enum_id: 3,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "RearCarCallUnlock",
      description: "RearCarCallUnlock",
      command: true,
    },
    {
      id: "c2641687-4ca5-4048-bfd1-b9500e3b31f3",
      enum_id: 16,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeCarCall",
      description: "EnergizeCarCall",
      command: true,
    },
    {
      id: "52a20aa3-d605-4fb0-b0bb-a32021c012c6",
      enum_id: 17,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeRearCarCall",
      description: "EnergizeRearCarCall",
      command: true,
    },
    {
      id: "77f84dcf-cb96-47f2-a0df-70f57cb3ed05",
      enum_id: 22,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "SecureCarCall",
      description: "SecureCarCall",
      command: false,
    },
    {
      id: "c9233251-d10c-4e1c-a405-d65c077ca1f5",
      enum_id: 23,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "SecureRearCarCall",
      description: "SecureRearCarCall",
      command: false,
    },
    {
      id: "9dbc6967-87f6-4e98-ba54-98560603d1e4",
      enum_id: 4,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpHallCallLock",
      description: "UpHallCallLock",
      command: true,
    },
    {
      id: "4284dff4-91e9-4263-a5cf-9cb435c0f44e",
      enum_id: 5,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpHallCallUnlock",
      description: "UpHallCallUnlock",
      command: true,
    },
    {
      id: "6aee30b0-f7ff-419d-a55b-1f00626406ad",
      enum_id: 10,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownHallCallLock",
      description: "DownHallCallLock",
      command: true,
    },
    {
      id: "aca19062-a962-4e57-83b9-99ab4fe9ea39",
      enum_id: 11,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownHallCallUnlock",
      description: "DownHallCallUnlock",
      command: true,
    },
    {
      id: "797ca9ac-8115-42f6-98aa-d976848a2f91",
      enum_id: 6,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpRearHallCallLock",
      description: "UpRearHallCallLock",
      command: true,
    },
    {
      id: "840f76cc-21f6-45f7-8a78-a923a74c040d",
      enum_id: 7,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpRearHallCallUnlock",
      description: "UpRearHallCallUnlock",
      command: true,
    },
    {
      id: "6925af3f-bf8a-474f-9f46-65095e30f011",
      enum_id: 8,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownRearHallCallLock",
      description: "DownRearHallCallLock",
      command: true,
    },
    {
      id: "33aa966d-7d51-4310-82f5-84669fccccac",
      enum_id: 9,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownRearHallCallUnlock",
      description: "DownRearHallCallUnlock",
      command: true,
    },
    {
      id: "6925af3f-bf8a-474f-9f46-65095e30f011",
      enum_id: 8,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpAssignedHallCall",
      description: "UpAssignedHallCall",
      command: true,
    },
    {
      id: "13f30eff-9789-44af-a2a5-9cc8c212bcbe",
      enum_id: 14,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownAssignedHallCall",
      description: "DownAssignedHallCall",
      command: true,
    },
    {
      id: "33aa966d-7d51-4310-82f5-84669fccccac",
      enum_id: 9,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpAssignedRearHallCall",
      description: "UpAssignedRearHallCall",
      command: true,
    },
    {
      id: "3fe369a8-e218-4939-a9a7-cb09787a6dce",
      enum_id: 15,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownAssignedRearHallCall",
      description: "DownAssignedRearHallCall",
      command: true,
    },
    {
      id: "4cf2ffb1-1cd9-4610-88f4-c3c9ba822ad3",
      enum_id: 18,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeUpHallCall",
      description: "EnergizeUpHallCall",
      command: false,
    },
    {
      id: "f5514348-6638-4f1f-ba11-90e1be5fe796",
      enum_id: 19,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeUpRearHallCall",
      description: "EnergizeUpRearHallCall",
      command: false,
    },
    {
      id: "273d6451-6f0f-402e-9341-028b1ddfea47",
      enum_id: 20,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeDownHallCall",
      description: "EnergizeDownHallCall",
      command: false,
    },
    {
      id: "be06bfdc-bd7a-4cf3-b83a-db1694ba2aa4",
      enum_id: 21,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeDownRearHallCall",
      description: "EnergizeDownRearHallCall",
      command: false,
    },
    {
      id: "b3c3c3dc-1d2a-4633-8f8e-71fe65851d5d",
      enum_id: 24,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "VIP",
      description: "VIP",
      command: true,
    },
  ],
  PRODUCTION: [
    {
      id: "e8f6eaf4-e004-476f-a513-00b04936820f",
      enum_id: 0,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "RunUp",
      description: "RunUp",
    },
    {
      id: "a8070199-095f-466b-a599-4d9fba802790",
      enum_id: 1,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "RunDown",
      description: "RunDown",
    },
    {
      id: "fb449453-5395-4774-a3d3-2d594b91e712",
      enum_id: 2,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "Stop",
      description: "Stop",
    },
    {
      id: "db07b57a-ba2a-4c32-bebc-3019cfcf0959",
      enum_id: 0,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "CarCallLock",
      description: "CarCallLock",
      command: true,
    },
    {
      id: "7d85761a-197a-4419-b163-9b332bea0905",
      enum_id: 1,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "CarCallUnlock",
      description: "CarCallUnlock",
      command: true,
    },
    {
      id: "f2d7a18e-6cf5-4a20-af22-a079dd71a91e",
      enum_id: 2,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "RearCarCallLock",
      description: "RearCarCallLock",
      command: true,
    },
    {
      id: "afa7d515-fb5d-40ca-8004-0545f0df4239",
      enum_id: 3,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "RearCarCallUnlock",
      description: "RearCarCallUnlock",
      command: true,
    },
    {
      id: "c2641687-4ca5-4048-bfd1-b9500e3b31f3",
      enum_id: 16,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeCarCall",
      description: "EnergizeCarCall",
      command: true,
    },
    {
      id: "52a20aa3-d605-4fb0-b0bb-a32021c012c6",
      enum_id: 17,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeRearCarCall",
      description: "EnergizeRearCarCall",
      command: true,
    },
    {
      id: "77f84dcf-cb96-47f2-a0df-70f57cb3ed05",
      enum_id: 22,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "SecureCarCall",
      description: "SecureCarCall",
      command: false,
    },
    {
      id: "c9233251-d10c-4e1c-a405-d65c077ca1f5",
      enum_id: 23,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "SecureRearCarCall",
      description: "SecureRearCarCall",
      command: false,
    },
    {
      id: "9dbc6967-87f6-4e98-ba54-98560603d1e4",
      enum_id: 4,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpHallCallLock",
      description: "UpHallCallLock",
      command: true,
    },
    {
      id: "4284dff4-91e9-4263-a5cf-9cb435c0f44e",
      enum_id: 5,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpHallCallUnlock",
      description: "UpHallCallUnlock",
      command: true,
    },
    {
      id: "6aee30b0-f7ff-419d-a55b-1f00626406ad",
      enum_id: 10,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownHallCallLock",
      description: "DownHallCallLock",
      command: true,
    },
    {
      id: "aca19062-a962-4e57-83b9-99ab4fe9ea39",
      enum_id: 11,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownHallCallUnlock",
      description: "DownHallCallUnlock",
      command: true,
    },
    {
      id: "797ca9ac-8115-42f6-98aa-d976848a2f91",
      enum_id: 6,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpRearHallCallLock",
      description: "UpRearHallCallLock",
      command: true,
    },
    {
      id: "840f76cc-21f6-45f7-8a78-a923a74c040d",
      enum_id: 7,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpRearHallCallUnlock",
      description: "UpRearHallCallUnlock",
      command: true,
    },
    {
      id: "6925af3f-bf8a-474f-9f46-65095e30f011",
      enum_id: 8,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownRearHallCallLock",
      description: "DownRearHallCallLock",
      command: true,
    },
    {
      id: "33aa966d-7d51-4310-82f5-84669fccccac",
      enum_id: 9,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownRearHallCallUnlock",
      description: "DownRearHallCallUnlock",
      command: true,
    },
    {
      id: "6925af3f-bf8a-474f-9f46-65095e30f011",
      enum_id: 8,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpAssignedHallCall",
      description: "UpAssignedHallCall",
      command: true,
    },
    {
      id: "13f30eff-9789-44af-a2a5-9cc8c212bcbe",
      enum_id: 14,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownAssignedHallCall",
      description: "DownAssignedHallCall",
      command: true,
    },
    {
      id: "33aa966d-7d51-4310-82f5-84669fccccac",
      enum_id: 9,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpAssignedRearHallCall",
      description: "UpAssignedRearHallCall",
      command: true,
    },
    {
      id: "3fe369a8-e218-4939-a9a7-cb09787a6dce",
      enum_id: 15,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownAssignedRearHallCall",
      description: "DownAssignedRearHallCall",
      command: true,
    },
    {
      id: "4cf2ffb1-1cd9-4610-88f4-c3c9ba822ad3",
      enum_id: 18,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeUpHallCall",
      description: "EnergizeUpHallCall",
      command: false,
    },
    {
      id: "f5514348-6638-4f1f-ba11-90e1be5fe796",
      enum_id: 19,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeUpRearHallCall",
      description: "EnergizeUpRearHallCall",
      command: false,
    },
    {
      id: "273d6451-6f0f-402e-9341-028b1ddfea47",
      enum_id: 20,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeDownHallCall",
      description: "EnergizeDownHallCall",
      command: false,
    },
    {
      id: "be06bfdc-bd7a-4cf3-b83a-db1694ba2aa4",
      enum_id: 21,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeDownRearHallCall",
      description: "EnergizeDownRearHallCall",
      command: false,
    },
    {
      id: "b3c3c3dc-1d2a-4633-8f8e-71fe65851d5d",
      enum_id: 24,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "VIP",
      description: "VIP",
      command: true,
    },
  ],
  OFFLINE: [
    {
      id: "e8f6eaf4-e004-476f-a513-00b04936820f",
      enum_id: 0,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "RunUp",
      description: "RunUp",
    },
    {
      id: "a8070199-095f-466b-a599-4d9fba802790",
      enum_id: 1,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "RunDown",
      description: "RunDown",
    },
    {
      id: "fb449453-5395-4774-a3d3-2d594b91e712",
      enum_id: 2,
      message_type_id: 0,
      device_type: "ESCALATOR",
      message_content_type: 2,
      short_message: "Stop",
      description: "Stop",
    },
    {
      id: "db07b57a-ba2a-4c32-bebc-3019cfcf0959",
      enum_id: 0,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "CarCallLock",
      description: "CarCallLock",
      command: true,
    },
    {
      id: "7d85761a-197a-4419-b163-9b332bea0905",
      enum_id: 1,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "CarCallUnlock",
      description: "CarCallUnlock",
      command: true,
    },
    {
      id: "f2d7a18e-6cf5-4a20-af22-a079dd71a91e",
      enum_id: 2,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "RearCarCallLock",
      description: "RearCarCallLock",
      command: true,
    },
    {
      id: "afa7d515-fb5d-40ca-8004-0545f0df4239",
      enum_id: 3,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "RearCarCallUnlock",
      description: "RearCarCallUnlock",
      command: true,
    },
    {
      id: "c2641687-4ca5-4048-bfd1-b9500e3b31f3",
      enum_id: 16,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeCarCall",
      description: "EnergizeCarCall",
      command: true,
    },
    {
      id: "52a20aa3-d605-4fb0-b0bb-a32021c012c6",
      enum_id: 17,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeRearCarCall",
      description: "EnergizeRearCarCall",
      command: true,
    },
    {
      id: "77f84dcf-cb96-47f2-a0df-70f57cb3ed05",
      enum_id: 22,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "SecureCarCall",
      description: "SecureCarCall",
      command: false,
    },
    {
      id: "c9233251-d10c-4e1c-a405-d65c077ca1f5",
      enum_id: 23,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "SecureRearCarCall",
      description: "SecureRearCarCall",
      command: false,
    },
    {
      id: "9dbc6967-87f6-4e98-ba54-98560603d1e4",
      enum_id: 4,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpHallCallLock",
      description: "UpHallCallLock",
      command: true,
    },
    {
      id: "4284dff4-91e9-4263-a5cf-9cb435c0f44e",
      enum_id: 5,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpHallCallUnlock",
      description: "UpHallCallUnlock",
      command: true,
    },
    {
      id: "6aee30b0-f7ff-419d-a55b-1f00626406ad",
      enum_id: 10,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownHallCallLock",
      description: "DownHallCallLock",
      command: true,
    },
    {
      id: "aca19062-a962-4e57-83b9-99ab4fe9ea39",
      enum_id: 11,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownHallCallUnlock",
      description: "DownHallCallUnlock",
      command: true,
    },
    {
      id: "797ca9ac-8115-42f6-98aa-d976848a2f91",
      enum_id: 6,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpRearHallCallLock",
      description: "UpRearHallCallLock",
      command: true,
    },
    {
      id: "840f76cc-21f6-45f7-8a78-a923a74c040d",
      enum_id: 7,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpRearHallCallUnlock",
      description: "UpRearHallCallUnlock",
      command: true,
    },
    {
      id: "6925af3f-bf8a-474f-9f46-65095e30f011",
      enum_id: 8,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownRearHallCallLock",
      description: "DownRearHallCallLock",
      command: true,
    },
    {
      id: "33aa966d-7d51-4310-82f5-84669fccccac",
      enum_id: 9,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownRearHallCallUnlock",
      description: "DownRearHallCallUnlock",
      command: true,
    },
    {
      id: "6925af3f-bf8a-474f-9f46-65095e30f011",
      enum_id: 8,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpAssignedHallCall",
      description: "UpAssignedHallCall",
      command: true,
    },
    {
      id: "13f30eff-9789-44af-a2a5-9cc8c212bcbe",
      enum_id: 14,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownAssignedHallCall",
      description: "DownAssignedHallCall",
      command: true,
    },
    {
      id: "33aa966d-7d51-4310-82f5-84669fccccac",
      enum_id: 9,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "UpAssignedRearHallCall",
      description: "UpAssignedRearHallCall",
      command: true,
    },
    {
      id: "3fe369a8-e218-4939-a9a7-cb09787a6dce",
      enum_id: 15,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "DownAssignedRearHallCall",
      description: "DownAssignedRearHallCall",
      command: true,
    },
    {
      id: "4cf2ffb1-1cd9-4610-88f4-c3c9ba822ad3",
      enum_id: 18,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeUpHallCall",
      description: "EnergizeUpHallCall",
      command: false,
    },
    {
      id: "f5514348-6638-4f1f-ba11-90e1be5fe796",
      enum_id: 19,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeUpRearHallCall",
      description: "EnergizeUpRearHallCall",
      command: false,
    },
    {
      id: "273d6451-6f0f-402e-9341-028b1ddfea47",
      enum_id: 20,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeDownHallCall",
      description: "EnergizeDownHallCall",
      command: false,
    },
    {
      id: "be06bfdc-bd7a-4cf3-b83a-db1694ba2aa4",
      enum_id: 21,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "EnergizeDownRearHallCall",
      description: "EnergizeDownRearHallCall",
      command: false,
    },
    {
      id: "b3c3c3dc-1d2a-4633-8f8e-71fe65851d5d",
      enum_id: 24,
      message_type_id: 0,
      device_type: "ELEVATOR",
      message_content_type: 2,
      short_message: "VIP",
      description: "VIP",
      command: true,
    },
  ],
};
